import React from 'react';
import Lottie from 'lottie-react';

const LottieItem = ({ title, text, lottieAnimation }) => {
    return (
        <div className="flex flex-col space-y-10 lg:flex-row lg:space-y-0 h-full">
            <div className="flex flex-col justify-between lg:w-3/5 z-10">
                <h1 className="card-title">{title}​​</h1>
                <span className="text-card-text-color text-justify md:text-left">
                    {text}
                </span>
            </div>
            <div className="flex w-2/5 justify-center self-center max-h-28">
                <div className="relative w-28 h-28">
                    <div className="ornament-circle big"></div>
                    <div className="ornament-circle medium"></div>
                    <div className="ornament-circle small"></div>
                    <Lottie animationData={lottieAnimation} />
                </div>
            </div>
        </div>
    );
};

export default LottieItem;
